import axios from "axios";
import Modal from "./Modal";

// 当クラスはモーダルの開きと閉じの処理を担当する
// 「Modal」のクラスを利用しています。
class Filter extends Modal {
    constructor({modalId, modalCloser, modalOpener}) {
        // 「Modal」クラスの以下の引数を上書する
        super({modalId, modalCloser, modalOpener});

        this.filterIsOpen = false;
        this.windowPosition;
        this.filterIputs = {
            category: [],
            search: '',
            strict: false
        }
        this.productFilterForm = document.getElementById('productFilterForm');
        this.searchInput = document.querySelector('.product-filter__form-search');
        this.searchResultCounter = document.getElementById('searchResultCounter');
        this.typingTimer;
        this.previousSearchValue;
        this.postsWrapper = document.getElementById('productPosts');

        // 必須の要素がある場合のみに、ブラウザやDOMのイベントを監視する
        if(this.modalOpeners && this.modal && this.postsWrapper) {
            this.filterEvent();
        }
    }

    // ============
    // Events
    // =============
    filterEvent() {
        this.modalOpeners.forEach(opener => {
            opener.addEventListener('click', this.showPostsCounter.bind(this))
        });
        this.modalCloser.addEventListener('click', this.hidePostsCounter.bind(this));
        document.addEventListener('keyup', event => this.handleFilterKeyboardPress(event));
        document.addEventListener('keydown', event => this.handleEnterPress(event));
        this.productFilterForm.addEventListener('submit', event => event.preventDefault);
        this.productFilterForm.addEventListener('change', event => this.handleFilter(event));
        this.searchInput.addEventListener('keyup', event => this.typingLogic(event));
        this.searchInput.addEventListener('search', event => this.typingLogic(event));
    }

    // ============
    // Methods
    // =============
    
    //検索結果の投稿数を表示するバーの表示 
    showPostsCounter() {
        this.searchResultCounter.style.transform = 'translateY(0)';
    }
    
    //検索結果の投稿数を表示するバーの非表示 
    hidePostsCounter() {
        this.searchResultCounter.style.transform = '';
    }
    
    // エンターボタンを押した際の処理
    handleEnterPress(event) {
        if(this.modalIsOpen && event.keyCode && event.keyCode === 13) {
            event.preventDefault();
            this.handleModalClose();
            this.hidePostsCounter();
        }
    }

    // キーボード操作の処理
    handleFilterKeyboardPress(event) {
        if(!this.navMenu.classList.contains('is-visible')) {
            if(event.keyCode && event.keyCode === 27) {
                this.hidePostsCounter();
            }
            if(event.keyCode && event.keyCode !== 17 && event.keyCode === 70 && !this.filterIsOpen) {
                this.openModal();
                this.showPostsCounter(this.modal);
            }
        }

    }

    // フィルター機能
    handleFilter(event) {
        // カテゴリー
        if(event.target.name === 'cat') {
            if(event.target.checked) {
                if(this.filterIputs.category.indexOf(event.target.value) === -1) {
                    this.filterIputs.category.push(event.target.value);
                }
            }else {
                const index = this.filterIputs.category.indexOf(event.target.value);
                this.filterIputs.category.splice(index, 1);
            }
        }
        if(event.target.name === 'strict') {
            this.filterIputs.strict = event.target.checked;
        }


        this.fetchData();
    }

    // キーボードを操作してからの処理が始まるまでの時間設定
    typingLogic(event) {
        if(this.searchInput.value !== this.previousSearchValue) {
            clearTimeout(this.typingTimer)
        }

        this.typingTimer = setTimeout(() => {
            this.handleSearch(event);
            this.previousSearchValue = this.searchInput.value;
        }, 750);
        
    }

    // 入力検索
    handleSearch(event) {
        this.filterIputs.search = event.target.value.toLowerCase();
        this.fetchData();
    }

    // 結果を取得する
    fetchData() {
        axios.interceptors.request.use(request => {
            this.productFilterForm.style.pointerEvents = 'none'
            this.searchResultCounter.querySelector('.product-filter__counter-waiter').style.display = 'block';
            return request;
        })
          

        axios.get(ftsLocalizedScripts.siteUrl + '/wp-json/fts/v1/filter?category=' + this.filterIputs.category + '&search=' + this.filterIputs.search + '&strict=' + this.filterIputs.strict) 
        .then((response) => {
            this.updateMarkup(response.data);
        })
    }

    // 検索結果の投稿を表示する
    updateMarkup(data) {
        const {count, posts } = data;
        let result = '';
        if(count > 0) {

            result = posts.map(({
                title, 
                premalink, 
                thumbnail, 
                tags, 
                description,
                label,
                labelSlug
            }) => (
                    `
                        <li class="product-card">
                        <a href="${premalink}" class="product-card__inner">
                            <div class="product-card__thumb">
                                ${(label && labelSlug !== 'none') ? label : ''}
                                <img src="${thumbnail}" alt="${title}" class="product-card__thumb-img">
                            </div>
                            <div class="product-card__content">
                                
                                ${description && 
                                    `
                                    <p class="product-card__description">${description}</p>
                                    `
                                }
                                <h3 class="product-card__name" >${title}</h3>
                                <div class="product-card__row">
                                    <ul class="product-card__meta-tags tag-list">
                                    ${tags.map(tag => {
                                        return (
                                            `<li class="product-card__meta-tags-item tag-list__item">${tag.name}</li>`
                                        )
                                    }).join("")}
                                    </ul>
                                    <p class="product-card__btn"></p>
                                </div>
                            </div>
                        </a>
                    </li>
                    `
                )
            ).join("");
        }else {
            result = `<p>もう一度お試しください</p>`;
        }
        this.postsWrapper.innerHTML = result;
        this.productFilterForm.style.pointerEvents = ''
        this.searchResultCounter.querySelector('.product-filter__counter-waiter').style.display  = 'none';
        this.searchResultCounter.querySelector('.product-filter__counter-number').innerHTML = count;

    }
}

export default Filter;